import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Breadcrumb, Typography, Spin } from 'antd';
import { formItemLayout, unexpectedError, tailFormItemLayout, handleBackendFormErrors, backButton } from '../../common_functions';
const Annotations = props => {
  const { section, id } = useParams();
  const [annotation, setAnnotation] = useState({});
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (id !== 'new') {
          const { data } = await props.getItem('annotation_materials', id);
          setAnnotation(data);
          formRef.current.setFieldsValue(data);
        }
      } catch (error) {
        console.error(error);
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [section, id]);

  let onFinish = async values => {
    setLoading(true);
    try {
      let newState = { ...annotation, ...values };
      const response = await props.saveItem('annotation_materials', newState);
      if (response) {
        notification.success({
          message: 'Annotation saved successfully!',
          duration: 2,
        });
        backButton(props, `/settings/annotation-materials`);
      }
    } catch (errorResponse) {
      handleBackendFormErrors(formRef, errorResponse);
    } finally {
      setLoading(false);
    }
  };
  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };
  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/annotation-materials" }, { title: "Annotation Materials", href: "/settings/annotation-materials" }, { title: id !== 'new' ? `Edit Annotation Material` : 'Add Annotation Material' }]} />
        </Col>
        <Col className="white-paper">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {id !== 'new' ? `Edit Annotation Material: ${id}` : 'Add Annotation Material'}
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end"></Col>
          </Row>
          <hr />
          <div className="artist">
            <Form
              ref={formRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ layout: tailFormItemLayout }}
            >
              {id !== 'new' && (
                <Row gutter={24}>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item name="id" label="ID(System Generated)">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                </Row>
              )}

              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="name"
                    label="Annotation"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Annotation is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Annotation" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item name="description" label="Description">
                    <Input.TextArea rows={5} placeholder="Enter description..." />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="default"
                  htmlType="button"
                  onClick={() => backButton(props, '/settings/annotation-materials')}
                  style={{
                    borderColor: '#d9d9d9',
                    background: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.85)',
                  }}
                >
                  Back
                </Button>
                {props.showButton(props.roleType, props.tabs_permissions.settings_annotation_materials, !!annotation ? annotation.id : '')}
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default Annotations;
